import React, { useState, useEffect, useRef, useCallback } from "react";
import {
  Box,
  Grid,
  TextField,
  Button,
  Tooltip,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  InputAdornment,
  Container,
  CircularProgress,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import {
  Row,
  Col,
  Form,
  InputGroup,
  OverlayTrigger,
  Modal,
} from "react-bootstrap";
import InfoIcon from "@mui/icons-material/Info";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import "bootstrap/dist/css/bootstrap.min.css";
import { useSelector } from "react-redux";
import loginSlider from "../../Assets/Images/login-slider.jpg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { set, useForm, Controller } from "react-hook-form";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import {
  ADDR,
  OPTIONS_FOR_FINGERPRINT,
  showToast,
  WEBSERVICE,
} from "../../CoreDataService";
import axios from "axios";
// import Select from "react-select";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import Fingerprint2 from "fingerprintjs2";
import Cookies from "js-cookie";
import {
  isMobile,
  isTablet,
  isDesktop,
  browserName,
  browserVersion,
} from "react-device-detect";
import PaybitoCaptcha from "../../Custom-component/PaybitoCaptcha";
import { allowOnlyAlphabetsCityState } from "../IdentityVerification";
import SocialLogin from "../Login/SocialLogin";

function Signup() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const referralCode = searchParams.get("referral_code");
  const franchiseCode = searchParams.get("franchise_code");
  const companyName = localStorage.getItem("companyName");
  const exchange = localStorage.getItem("exchange");
  const { brokerBasicInfo, brokerDetailedInfo } = useSelector((state) => state);
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [retypePasswordVisible, setRetypePasswordVisible] = useState(false);
  const [countryFlag, setCountryFlag] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [deviceDetails, setDeviceDetails] = useState(null);
  const [exchangeUnderOpecCountry, setExchangeUnderOpecCountry] = useState(0);

  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredCountries, setFilterCountry] = useState([]);
  const captchaRef = useRef(null);
  const [showPhoneDisclaimer, setShowPhoneDisclaimer] = useState(false);
  const [showBrokerIdDialog, setShowBrokerIdDialog] = useState(false);
  const [isMatched, setIsMatched] = useState(false);
  const [isBrokerLoaded, setIsBrokerLoaded] = useState(false);
  var [brokerSocialLogin, setBrokerSocialLogin] = useState(false);
  console.log("franch", franchiseCode);

  useEffect(() => {
    const isLoading =
      !brokerBasicInfo ||
      Object.keys(brokerBasicInfo).length === 0 ||
      !brokerDetailedInfo ||
      Object.keys(brokerDetailedInfo).length === 0;

    setIsBrokerLoaded(!isLoading);
    if (brokerDetailedInfo.socialLogin == 1) {
      setBrokerSocialLogin(true);
    } else {
      setBrokerSocialLogin(false);
    }
  }, [brokerBasicInfo, brokerDetailedInfo]);

  const brokerIdRef = useRef(null);

  const copyBrokerId = () => {
    if (brokerIdRef.current) {
      brokerIdRef.current.select();
      brokerIdRef.current.setSelectionRange(0, 99999); // For mobile devices
      navigator.clipboard.writeText(brokerIdRef.current.value);
      showToast("success", "Broker Id Copied");
    }
  };
  const {
    register,
    handleSubmit,
    control,
    formState: { errors, isValid, isSubmitting },
    trigger,
    watch,
    setValue,
    setError,
    clearErrors,
    getValues,
  } = useForm({
    mode: "onChange",
  });

  const [referredByUser, setReferredByUser] = useState("");
  const [referrerTypeUser, setReferrerTypeUser] = useState("");
  const [title, setTitle] = useState("Mr.");

  useEffect(() => {
    setValue("brokerId", brokerBasicInfo?.brokerId);
    setValue("referralCode", referralCode);
  }, [brokerBasicInfo]);

  const togglePasswordVisibility = () => {
    setPasswordVisible(!passwordVisible);
  };

  const toggleRetypePasswordVisibility = () => {
    setRetypePasswordVisible(!retypePasswordVisible);
  };

  var frontPagebakgColor =
    "linear-gradient(90deg, " +
    brokerDetailedInfo?.color?.backgroundColor1 +
    " 0%, " +
    brokerDetailedInfo?.color?.backgroundColor2 +
    " 60%)";

  var backgroundStyle = "";

  if (brokerDetailedInfo?.color?.isBackgroundImage == 0) {
    backgroundStyle = {
      background: frontPagebakgColor,
    };
  } else {
    backgroundStyle = {
      backgroundImage: `url(${brokerDetailedInfo?.color?.backgroundImageLink})`,
      backgroundRepeat: `no-repeat`,
      backgroundSize: `cover`,
      backgroundPosition: `center`,
      minHeight: `100%`,
    };
  }

  console.log("add debugger");

  const onSubmit = async (data) => {
    try {
      const { token } = await captchaRef.current.verify();
      SubmitCaptcha(token, null, data);
    } catch (err) {
      if (err.message !== "captcha-cancelled") {
        showToast("error", err.message || "Captcha verification failed");
      }
    }
  };
  const generateUUID = () => {
    Fingerprint2.get(OPTIONS_FOR_FINGERPRINT, (components) => {
      const values = components.map((component) => component.value);
      const hash = Fingerprint2.x64hash128(values.join(""), 31);
      localStorage.setItem("deviceId", hash);
      Cookies.set("deviceID", hash, { expires: 60 }); // 60 days

      console.log("Device ID:", hash);
      return hash;
    });
  };

  const SubmitCaptcha = async (captcha, sessionId, data) => {
    const payload = {
      country: selectedCountry?.country,
      latitude: deviceDetails?.latitude,
      longitude: deviceDetails?.longitude,
      ipAddress: deviceDetails?.ip,
      location: deviceDetails?.country_name,
      brokerId: data?.brokerId,
      email: data?.email,
      password: data?.password,
      firstName: data?.firstName,
      lastName: data?.lastName,
      gender: title,
      phone: data?.phone,
      repassword1: data?.retypePassword,
      countryCode: selectedCountry?.value,

      deviceId: Cookies.get("deviceID"),
      deviceType: isMobile
        ? "mobile"
        : isTablet
        ? "tablet"
        : isDesktop
        ? "Desktop browser"
        : "unknown",
      browser: `${browserName} ${browserVersion}`,
      gRecaptchaResponse: captcha,
      sessionId: sessionId,
      referralCode: null,
    };
    if (franchiseCode) {
      payload.referredBy = franchiseCode;
      payload.referrerType = "F";
    } else if (data?.referralCode) {
      payload.referredBy = data?.referralCode;
      payload.referrerType = "U";
    }
    try {
      const response = await axios.post(
        `${WEBSERVICE}user/AddUserDetails`,
        payload
      );
      if (response?.data?.error?.error_data === 0) {
        showToast(
          "success",
          "Please check your email for the verification token to complete the registration."
        );
        localStorage.setItem("emailForUser", data.email);
        localStorage.setItem("phoneUsedForRegistration", payload.phone);
        localStorage.setItem(
          "phoneCountryUsedForRegistration",
          payload.countryCode
        );
        localStorage.setItem("userId", response?.data?.userResult?.userId);
        localStorage.setItem(
          "phoneNumberActiveStatus",
          response?.data?.userResult?.enablePhoneOtp
        );
        navigate("/otp");
      } else {
        showToast("error", response?.data?.error?.error_msg);
      }
    } catch (e) {
      console.log("error in signup", e);
      showToast("error", e?.response?.data?.error?.error_msg);
    }
  };

  const checkEmail = (email) => {
    if (email) {
      const emailObj = { email };

      axios
        .post(`${WEBSERVICE}user/CheckEmail`, emailObj, {
          headers: { "Content-Type": "application/json" },
        })
        .then((response) => {
          const result = response.data;
          if (result.error.error_data !== 0) {
            showToast("error", result.error.error_msg);
          } else if (result.userResult.checkEmailPhoneFlag === 1) {
            showToast(
              "warning",
              "Email already registered, reset your password or try with another email address."
            );
          }
        })
        .catch(() => {
          showToast("error", "Internal Server Error");
        });
    } else {
      showToast("warning", "Please Provide Email Id");
    }
  };

  useEffect(() => {
    // console.log('brokerBasicInfo', brokerBasicInfo);

    getCountryFlag();
    getDeviceDetails();
  }, [brokerBasicInfo, exchangeUnderOpecCountry]);

  useEffect(() => {
    if (watch("retypePassword")) {
      if (watch("retypePassword") !== watch("password")) {
        setError("retypePassword", {
          type: "manual",
          message: "Passwords do not match",
        });
        setIsMatched(false);
      } else {
        clearErrors("retypePassword");
        setIsMatched(true);
      }
    } else {
      // nothing typed yet
      setIsMatched(false);
      clearErrors("retypePassword");
    }
  }, [watch("retypePassword"), watch("password"), setError, clearErrors]);

  const getCountryFlag = async () => {
    const response = await axios.get(
      `${ADDR}/getExchangeCountries/${brokerBasicInfo.brokerId}`
    );

    const sortCountry = response?.data?.countries
      ?.sort((a, b) =>
        a.country.toLowerCase().localeCompare(b.country.toLowerCase())
      )
      ?.map((country) => ({
        value: country.dialCode,
        country: country.country,
        label: `(+${country.dialCode}) ${country.country}`,
        flag: `https://flagcdn.com/w40/${country.code.toLowerCase()}.png`,
        code: country.code.toLowerCase(),
      }));

    if (exchangeUnderOpecCountry === 1) {
      // const filterData = sortCountry?.filter(
      //   (d) => d?.value === "98" || d?.value === "7"
      // );
      // setCountryFlag(filterData);
      // setFilterCountry(filterData);
      // setSelectedCountry(filterData[0]);

      setCountryFlag(sortCountry);
      setFilterCountry(sortCountry);
      const selectedCountryCode = sortCountry?.filter(
        (d) => d?.country === "United States"
      );
      setSelectedCountry(selectedCountryCode[0]);
    } else {
      setCountryFlag(sortCountry);
      setFilterCountry(sortCountry);
      const selectedCountryCode = sortCountry?.filter(
        (d) => d?.country === "United States"
      );
      setSelectedCountry(selectedCountryCode[0]);
    }
  };
  const validatePhoneNumber = async (phone) => {
    if (selectedCountry) {
      if (phone) {
        const data = {
          countryCode: selectedCountry?.value,
          phone: phone,
        };
        const response = await axios.post(`${WEBSERVICE}user/CheckPhone`, data);
        if (response?.data?.error?.error_data === 1) {
          showToast("error", response?.data?.error?.error_msg);
          setValue("phone", "");
        } else {
          if (response?.data?.userResult.checkEmailPhoneFlag === 1) {
            showToast(
              "error",
              "Phone No. already registered , please try with another phone no."
            );
            setValue("phone", "");
          }
        }
      } else {
        showToast("warning", "Please Provide Phone No");
      }
    } else {
      showToast("error", "Please select phone country code");
    }
  };

  useEffect(() => {
    getCountryFromGeoLocation();
  }, []);

  const getCountryFromGeoLocation = async () => {
    try {
      const res = await axios.get(
        "https://de-api.ipgeolocation.io/ipgeo?apiKey=693da481af1b4a3e80e3dfea9115dc52"
      );
      const response = res.data;
      checkCountryIsopec(response.country_name);
    } catch (error) {
      console.error("Error in getCountryFromGeoLocation:", error);
    }
  };

  const checkCountryIsopec = async (country) => {
    try {
      const res = await axios.get(
        `https://accounts.paybito.com/api/home/ofacCheck/${country}`
      );
      const data = res.data;
      setExchangeUnderOpecCountry(data.isOfac);
    } catch (error) {
      console.error("Error in checkCountryIsopec:", error);
    }
  };

  useEffect(() => {
    handleFilterCountry();
  }, [searchTerm]);

  const handleFilterCountry = useCallback(() => {
    if (searchTerm !== "") {
      const filteredData = countryFlag.filter(
        (country) =>
          country.country.toLowerCase().includes(searchTerm.toLowerCase()) ||
          country.value.toString().includes(searchTerm)
      );
      setFilterCountry(filteredData);
    } else {
      setFilterCountry(countryFlag);
    }
  }, [searchTerm]);

  const getDeviceDetails = async () => {
    const response = await axios.get(
      "https://api.ipgeolocation.io/ipgeo?apiKey=693da481af1b4a3e80e3dfea9115dc52"
    );
    setDeviceDetails(response.data);
  };

  const textFieldStyle = {
    mt: 1,
    input: {
      color: "#333",
      "&::placeholder": {
        color: "#aaa", // Light gray placeholder color
        opacity: 1, // Ensure full opacity (some browsers reduce it)
      },
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: 2,
      "& fieldset": {
        borderColor: "#ccc",
      },
      "&:hover fieldset": {
        borderColor: "#888",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#1976d2",
      },
    },
    "& .MuiFormHelperText-root": {
      mt: 0.5,
    },
    "& label": {
      color: "#333",
      "&.Mui-focused": {
        color: "#1976d2",
      },
    },
  };

  const checkReferralCode = async () => {
    const code = getValues("referralCode")?.trim();
    if (code && code !== "") {
      const referralCodeObj = { referralCode: code };
      const jsonString = JSON.stringify(referralCodeObj);

      try {
        const response = await axios.post(
          `${WEBSERVICE}user/checkReferralCode`,
          jsonString,
          { headers: { "Content-Type": "application/json" } }
        );
        const result = response.data;

        if (result.error.error_data !== 0) {
          // show danger alert
          showToast("error", result.error.error_msg);
          // mark field as invalid in react-hook-form
          setError("referralCode", {
            type: "manual",
            message: "Enter a valid Referral Code",
          });
        } else {
          // showToast("success","valid Referral Code" );
          setReferredByUser(code);
          setReferrerTypeUser(result.userResult.referrerType);
          clearErrors("referralCode");
        }
      } catch (err) {
        showToast("error", "Internal Server Error");
      }
    } else {
      setReferredByUser("");
      setReferrerTypeUser("");
      clearErrors("referralCode");
    }
  };

  const passwordValue = watch("password", "");

  const allowedRegex = /^[A-Za-z0-9_-]{0,30}$/;

  const allowOnlyAlphabetsWithSpecial = (e, fieldName, maxLimit) => {
    const key = e.key;
    if (
      key === "Backspace" ||
      key === "Tab" ||
      key === "ArrowLeft" ||
      key === "ArrowRight" ||
      key === "Delete"
    ) {
      return;
    }
    const regex = /^[a-zA-Z\s'-]$/;
    if (!regex.test(key)) {
      e.preventDefault();
      return;
    }
    if (e.target.value.length >= maxLimit) {
      e.preventDefault();
      setError(fieldName, {
        type: "manual",
        message: `Maximum length: ${maxLimit} characters`,
      });
    }
  };

  const blockExtraCharacters = (e, fieldName, maxLimit) => {
    const key = e.key;
    if (
      key === "Backspace" ||
      key === "Tab" ||
      key === "ArrowLeft" ||
      key === "ArrowRight" ||
      key === "Delete"
    ) {
      return;
    }
    if (e.target.value.length >= maxLimit && key.length === 1) {
      e.preventDefault();
      setError(fieldName, {
        type: "manual",
        message: `Maximum length: ${maxLimit} characters`,
      });
    }
  };

  // Handle typing with filtering
  const handleInputChange = (e) => {
    const rawValue = e.target.value;
    // filter out invalid characters
    const filtered = rawValue
      .split("")
      .filter((ch) => /^[a-zA-Z0-9_-]$/.test(ch))
      .slice(0, 30) // hard slice
      .join("");
    setValue("referralCode", filtered, { shouldValidate: true });
  };

  return (
    <>
      {isBrokerLoaded ? (
        <Box
          sx={{
            ...backgroundStyle,
            display: "flex",
            justifyContent: "center",
            minHeight: "100vh",
            p: { xs: 2, sm: 4, md: 5 },
          }}
        >
          <Container
            sx={{
              width: { xs: "100%", md: "60%" }, // 100% on small screens, 60% on md and up
              maxWidth: "720px",
              my: 3,
            }}
          >
            <Box
              sx={{
                width: "100%",
                bgcolor: "white",
                p: { xs: 2, sm: 4 },
                borderRadius: 2,
              }}
            >
              <Typography
                variant="h5"
                gutterBottom
                sx={{ color: "#102ab3", textAlign: "center" }}
              >
                Ready to create your {brokerBasicInfo?.exchange} account?
              </Typography>

              <Typography
                variant="body2"
                gutterBottom
                sx={{ color: "#999898", textAlign: "center" }}
              >
                We're glad to hear it! We just need a few pieces of information
                to get you started.
              </Typography>

              <Box component="form" onSubmit={handleSubmit(onSubmit)}>
                <Grid container spacing={2}>
                  {/*Gender, First, Middle, Last Name */}
                  <Grid size={{ xs: 12, md: 2 }}>
                    <select
                      className="form-select"
                      onChange={(e) => setTitle(e.target.value)}
                      style={{ height: "55px", marginTop: "8px" }}
                    >
                      <option value="Mr.">Mr.</option>
                      <option value="Mrs.">Mrs.</option>
                      <option value="Ms.">Ms.</option>
                      <option value="Dr.">Dr.</option>
                      <option value="Other">Other</option>
                    </select>
                  </Grid>
                  <Grid size={{ xs: 12, md: 10 }}>
                    <Grid container spacing={2}>
                      <Grid size={4}>
                        <Tooltip title="Your name must match with your government ID.">
                          <TextField
                            fullWidth
                            label="First Name *"
                            autoComplete="off"
                            className="black-autofill"
                            {...register("firstName", {
                              required: "First name is required",
                              pattern: {
                                value: /^[A-Za-z\s'-]{2,50}$/,
                                message:
                                  "Allowed characters: Alphabets, Spaces, Hyphen (-), Apostrophe (')",
                              },
                              minLength: {
                                value: 2,
                                message: "Minimum length: 2 characters",
                              },
                              maxLength: {
                                value: 50,
                                message: "Maximum length: 50 characters",
                              },
                            })}
                            onKeyDown={(e) =>
                              allowOnlyAlphabetsWithSpecial(e, "firstName", 50)
                            }
                            error={!!errors.firstName}
                            helperText={errors.firstName?.message}
                            sx={textFieldStyle}
                            onBlur={(e) => {
                              setValue("firstName", e.target.value.trim(), {
                                shouldValidate: true,
                              });
                              clearErrors("firstName");
                              trigger("firstName");
                            }}
                          />
                        </Tooltip>
                      </Grid>

                      <Grid size={4}>
                        <TextField
                          fullWidth
                          label="Middle Name"
                          className="black-autofill"
                          {...register("middleName", {
                            pattern: {
                              value: /^[A-Za-z\s'-]{0,50}$/,
                              message:
                                "Allowed characters: Alphabets, Spaces, Hyphen (-), Apostrophe (')",
                            },
                            maxLength: {
                              value: 50,
                              message: "Maximum length: 50 characters",
                            },
                          })}
                          onKeyDown={(e) =>
                            allowOnlyAlphabetsWithSpecial(e, "middleName", 50)
                          }
                          error={!!errors.middleName}
                          helperText={errors.middleName?.message}
                          sx={textFieldStyle}
                          onBlur={(e) => {
                            setValue("middleName", e.target.value.trim(), {
                              shouldValidate: true,
                            });
                            clearErrors("middleName");
                            trigger("middleName");
                          }}
                        />
                      </Grid>

                      <Grid size={4}>
                        <TextField
                          fullWidth
                          label="Last Name *"
                          className="black-autofill"
                          {...register("lastName", {
                            required: "Last name is required",
                            pattern: {
                              value: /^[A-Za-z\s'-]{1,50}$/,
                              message:
                                "Allowed characters: Alphabets, Spaces, Hyphen (-), Apostrophe (')",
                            },
                            minLength: {
                              value: 1,
                              message: "Minimum length: 1 characters",
                            },
                            maxLength: {
                              value: 50,
                              message: "Maximum length: 50 characters",
                            },
                          })}
                          onKeyDown={(e) =>
                            allowOnlyAlphabetsWithSpecial(e, "lastName", 50)
                          }
                          error={!!errors.lastName}
                          helperText={errors.lastName?.message}
                          sx={textFieldStyle}
                          onBlur={(e) => {
                            setValue("lastName", e.target.value.trim(), {
                              shouldValidate: true,
                            });
                            clearErrors("lastName");
                            trigger("lastName");
                          }}
                        />
                      </Grid>
                    </Grid>
                  </Grid>

                  {/* Email */}
                  <Grid size={12}>
                    <TextField
                      fullWidth
                      label="Email *"
                      className="black-autofill"
                      type="email"
                      {...register("email", {
                        required: "Email is required",
                        pattern: {
                          value:
                            /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/,
                          message: "Invalid email address",
                        },
                        maxLength: {
                          value: 80,
                          message: "Maximum length: 80 characters",
                        },
                      })}
                      onKeyDown={(e) => blockExtraCharacters(e, "email", 80)}
                      onBlur={(e) => {
                        const val = e.target.value.trim();
                        setValue("email", val, { shouldValidate: true });
                        clearErrors("email");
                        trigger("email");
                        checkEmail(val);
                      }}
                      error={!!errors.email}
                      helperText={errors.email?.message}
                      sx={textFieldStyle}
                    />
                  </Grid>

                  <Grid size={12}>
                    <Form.Group controlId="phone" className="mt-1">
                      <InputGroup>
                        <div style={{ position: "relative" }}>
                          <div
                            onClick={() => setIsOpen(!isOpen)}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                              padding: "10px",
                              border: "1px solid #ccc",
                              borderRadius: "5px 0 0 5px",
                              cursor: "pointer",
                              height: "55px",
                              borderRight: "none",
                            }}
                          >
                            <img
                              src={
                                selectedCountry?.flag || countryFlag[0]?.flag
                              }
                              alt={
                                selectedCountry?.code || countryFlag[0]?.code
                              }
                            />
                          </div>

                          {/* Dropdown menu */}
                          {isOpen && (
                            <div
                              style={{
                                position: "absolute",
                                top: "100%",
                                left: 0,
                                width: "360px",
                                border: "1px solid #ccc",
                                borderRadius: "5px",
                                background: "#fff",
                                zIndex: 1000,
                                maxHeight: "200px",
                                overflowY: "auto",
                              }}
                            >
                              {/* Search bar */}
                              <input
                                type="text"
                                placeholder="Search country"
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                                style={{
                                  width: "100%",
                                  padding: "10px",
                                  border: "none",
                                  borderBottom: "1px solid #ccc",
                                  outline: "none",
                                }}
                              />
                              {/* Country list */}
                              {filteredCountries &&
                              filteredCountries.length !== 0 ? (
                                filteredCountries.map((country) => (
                                  <div
                                    // key={country.value}
                                    onClick={() => {
                                      setSelectedCountry(country);
                                      setIsOpen(false);
                                    }}
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      padding: "10px",
                                      cursor: "pointer",
                                      background:
                                        selectedCountry?.value ===
                                        country?.value
                                          ? "#f0f0f0"
                                          : "#fff",
                                    }}
                                  >
                                    <img
                                      src={country?.flag}
                                      alt={country?.code}
                                    />
                                    &nbsp;
                                    <span
                                      style={{ color: "#555" }}
                                    >{`+(${country?.value})`}</span>
                                    <span
                                      style={{
                                        marginLeft: "10px",
                                        color: "#555",
                                      }}
                                    >
                                      {country?.country}
                                    </span>
                                  </div>
                                ))
                              ) : (
                                <div style={{ padding: "10px", color: "#888" }}>
                                  No results found
                                </div>
                              )}
                            </div>
                          )}
                        </div>

                        <Controller
                          name="phone"
                          control={control}
                          rules={{
                            required: "Phone number is required",
                          }}
                          render={({ field }) => (
                            <PhoneInput
                              country={selectedCountry?.code || "us"}
                              value={
                                selectedCountry?.value + (field.value || "")
                              }
                              onChange={(value, country) => {
                                const dialCode = country.dialCode;
                                let onlyNumber = value;
                                if (value.startsWith(dialCode)) {
                                  onlyNumber = value.slice(dialCode.length);
                                }
                                field.onChange(onlyNumber);
                                clearErrors("phone");
                                trigger("phone");
                              }}
                              onBlur={() => {
                                field.onBlur();
                                validatePhoneNumber(field.value);
                                setShowPhoneDisclaimer(false);
                              }}
                              onFocus={() => setShowPhoneDisclaimer(true)}
                              disableDropdown={true}
                              placeholder="Phone number *"
                              inputClass="form-control black-autofill"
                              containerStyle={{ flex: 1 }}
                              buttonStyle={{ display: "none" }}
                              inputStyle={{
                                width: "100%",
                                height: "55px",
                                border: "1px solid #ccc",
                                borderRadius: "5px",
                                fontSize: "16px",
                                paddingLeft: "10px",
                              }}
                            />
                          )}
                        />
                      </InputGroup>
                      {showPhoneDisclaimer && (
                        <span style={{ color: "gray", fontSize: "11px" }}>
                          Messages and data rates may apply. If you choose to
                          receive MFA passwords as text messages, {exchange}{" "}
                          [company name: {companyName}] will send you one text
                          message per login attempt. To stop receiving messages,
                          reply STOP to the message. Alternatively, you can go
                          to the Settings menu, once you login and deactivate
                          phone authentication. Please review the Terms of use
                          and Privacy policy on this page.
                        </span>
                      )}
                      {errors.phone && (
                        <p className="text-danger">{errors.phone.message}</p>
                      )}
                    </Form.Group>
                  </Grid>

                  {/* Broker ID (readonly) */}
                  <Grid size={12} sx={{ display: "none" }}>
                    <TextField
                      fullWidth
                      label="Broker ID *"
                      className="black-autofill"
                      {...register("brokerId")}
                      focused
                      InputProps={{
                        // readOnly: true,
                        endAdornment: (
                          <InputAdornment position="end">
                            <Tooltip title="Broker ID Info">
                              <IconButton
                                onClick={() => setShowBrokerIdDialog(true)}
                                edge="end"
                              >
                                <InfoIcon sx={{ color: "#333" }} />
                              </IconButton>
                            </Tooltip>
                          </InputAdornment>
                        ),
                      }}
                      sx={textFieldStyle}
                    />
                  </Grid>

                  {/* Password */}
                  <Grid size={12}>
                    <TextField
                      fullWidth
                      label="Password *"
                      autoComplete="off"
                      className="black-autofill"
                      type={passwordVisible ? "text" : "password"}
                      {...register("password", {
                        required: "Password is required",
                        minLength: {
                          value: 8,
                          message: "Minimum 8 characters",
                        },
                        maxLength: {
                          value: 35,
                          message: "Maximum 35 characters",
                        },
                        pattern: {
                          value:
                            /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[$@.!])[A-Za-z\d$@.!]{8,35}$/,
                          message:
                            "The password should be minimum 8 and maximum 35 characters and must contain at least one uppercase, one lowercase, one number and one special character ($ @ . ! only).",
                        },
                      })}
                      onKeyDown={(e) => {
                        if (e.key === " ") {
                          e.preventDefault();
                          setError("password", {
                            type: "manual",
                            message: "Spaces are not allowed",
                          });
                          return;
                        }
                        blockExtraCharacters(e, "password", 35);
                      }}
                      onBlur={(e) => {
                        clearErrors("password");
                        trigger("password");
                      }}
                      error={!!errors.password}
                      helperText={errors.password?.message}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton onClick={togglePasswordVisibility}>
                              {passwordVisible ? (
                                <VisibilityIcon sx={{ color: "#333" }} />
                              ) : (
                                <VisibilityOffIcon sx={{ color: "#333" }} />
                              )}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                      sx={textFieldStyle}
                    />
                  </Grid>

                  {/* Retype Password */}
                  <Grid size={12}>
                    <TextField
                      fullWidth
                      label="Retype Password *"
                      className="black-autofill"
                      type={retypePasswordVisible ? "text" : "password"}
                      {...register("retypePassword", {
                        required: "Please retype your password",
                        validate: (value) =>
                          value === watch("password") ||
                          "Passwords do not match",
                      })}
                      onKeyDown={(e) => {
                        if (e.key === " ") {
                          e.preventDefault();
                          setError("retypePassword", {
                            type: "manual",
                            message: "Spaces are not allowed",
                          });
                          return;
                        }
                        blockExtraCharacters(e, "retypePassword", 35);
                      }}
                      onBlur={(e) => {
                        clearErrors("retypePassword");
                        trigger("retypePassword");
                      }}
                      error={!!errors.retypePassword}
                      helperText={errors.retypePassword?.message}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              onClick={toggleRetypePasswordVisibility}
                            >
                              {retypePasswordVisible ? (
                                <VisibilityIcon sx={{ color: "#333" }} />
                              ) : (
                                <VisibilityOffIcon sx={{ color: "#333" }} />
                              )}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                      sx={textFieldStyle}
                    />

                    {isMatched &&
                      !errors.retypePassword &&
                      !errors.password && (
                        <Typography
                          sx={{
                            color: "green",
                            fontSize: "0.75rem",
                            mt: "4px",
                          }}
                        >
                          Passwords Matched
                        </Typography>
                      )}
                  </Grid>

                  {/* Referral Code */}
                  {!franchiseCode && (
                    <Grid size={12}>
                      <TextField
                        fullWidth
                        className="black-autofill"
                        label="Referral Code (Optional)"
                        {...register("referralCode", {
                          pattern: {
                            value: /^[A-Za-z0-9_-]{0,30}$/,
                            message: "Enter a valid Referral Code",
                          },
                          maxLength: {
                            value: 30,
                            message: "Maximum length: 30 characters",
                          },
                        })}
                        onKeyDown={(e) =>
                          blockExtraCharacters(e, "referralCode", 30)
                        }
                        onBlur={(e) => {
                          clearErrors("referralCode");
                          trigger("referralCode");
                          checkReferralCode();
                        }}
                        onChange={handleInputChange}
                        sx={textFieldStyle}
                        error={!!errors.referralCode}
                        helperText={errors.referralCode?.message}
                      />
                    </Grid>
                  )}

                  {/* Submit Button */}
                  <Grid size={12}>
                    <Button
                      fullWidth
                      variant="contained"
                      type="submit"
                      disabled={!isValid || isSubmitting} // 🚀 disable when invalid or submitting
                      sx={{
                        backgroundColor:
                          brokerDetailedInfo?.color?.buttonColor || "#1976d2",
                        color: "#fff",
                        ":hover": {
                          backgroundColor:
                            brokerDetailedInfo?.color?.buttonColor || "#1251a0",
                        },
                        "&.Mui-disabled": {
                          backgroundColor: "#b0b0b0", // gray for disabled state
                          color: "#ffffff", // white text on disabled
                        },
                      }}
                    >
                      Submit
                    </Button>
                  </Grid>
                </Grid>
              </Box>

              <Typography
                variant="body2"
                align="center"
                sx={{ mt: 2, color: "#212529bf" }}
              >
                When you click Submit, we'll send you MFA codes to verify your
                phone and email.
              </Typography>

              <Typography
                variant="body2"
                align="center"
                sx={{ mt: 1, color: "#212529bf" }}
              >
                By registering, you agree to the{" "}
                <Link
                  to="/legal"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: "#1976d2", fontSize: "15px" }}
                >
                  Terms of Use
                </Link>{" "}
                and{" "}
                <Link
                  to="/privacy-policy"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: "#1976d2", fontSize: "15px" }}
                >
                  Privacy Policy
                </Link>
                .<br />
                <Link to="/" style={{ color: "#1976d2", fontSize: "15px" }}>
                  Already a member?
                </Link>
              </Typography>

              {brokerSocialLogin == true ? (
                <Box
                  display="flex"
                  justifyContent="center"
                  sx={{ marginTop: "0px" }}
                >
                  <SocialLogin purpose="your-purpose-value" />
                </Box>
              ) : (
                ""
              )}

              <PaybitoCaptcha ref={captchaRef} />
            </Box>
          </Container>
        </Box>
      ) : (
        <Box
          height="100vh"
          display="flex"
          alignItems="center"
          justifyContent="center"
          bgcolor="#f5f5f5"
        >
          <CircularProgress />
        </Box>
      )}

      <Dialog
        open={showBrokerIdDialog}
        onClose={() => setShowBrokerIdDialog(false)}
      >
        <DialogTitle>Broker ID Information</DialogTitle>
        <DialogContent>
          <Typography gutterBottom pt={2}>
            {brokerBasicInfo?.exchange} Broker / Membership ID is{" "}
            {brokerBasicInfo?.brokerId}.
          </Typography>
          <TextField
            inputRef={brokerIdRef}
            value={brokerBasicInfo?.brokerId || ""}
            readOnly
            fullWidth
            sx={{ display: "none" }}
          />
          <Typography gutterBottom>
            Please use this or the one provided by your Broker.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={copyBrokerId} sx={{ bgcolor: "orange" }}>
            Copy
          </Button>
          <Button
            onClick={() => setShowBrokerIdDialog(false)}
            sx={{ bgcolor: "orange" }}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default Signup;
